<template>
  <div class="row" style="width:100%;">
    <div class="col">
        <multiple-file-input id="file"
          @error="$toasted.error(arguments[1])"
          @success="handleUploadFile"
          @remove-file="handleRemoveFile"
          :fields="{ category_id: category.id, process_id: category.process_id }"
          :items="collection"
          :url="uploadUrl">

        </multiple-file-input>
    </div>
  </div>
</template>

<script>
  import { processItems } from '@/_entities'
  import { resolveHTTP } from '@/services/api'

  export default {
    props: {
      category: {
        required: true,
        type: Object
      }
    },

    data () {
      return {
        entity: null,
        http: null,

        options: {
          acceptedFileTypes: ['image/*'],
          clickable: false,
          adapterOptions: {
            url: './upload.php'
          }
        },

        // Data for removing the item
        item: null,
        removeModal: false,

        collection: []
      }
    },

    methods: {
      triggerBrowse () {
        this.$refs.uploader.triggerBrowseFiles()
      },

      refreshCollection () {
        const self = this

        self.$Progress.start()

        // Let's grab the most
        self.http.index({ params: {
          search: { 'category.id': self.category.id },
          _with: 'file',
          _onepage: true
        }}).then((res) => {
          self.$Progress.finish()
          self.collection = res.data.collection
        }).catch((e) => {
          self.$Progress.finish()
          // self.$toasted.error(e)
          console.error(e)
        })
      },

      handleUploadFile (file, response, progress) {
        if (this.form._attach_files === undefined) {
          this.form._attach_files = this.form.initial._attach_files || []
        }
        this.form._attach_files.push(response)
        this.file = response
      },

      handleRemoveFile (file) {
        if (this.instance.id) {
          this.confirmRemoveModal = true
          return null
        }

        this.clearFileInput()
      },

      clearFileInput () {
        this.form._attach_files = []
        this.file = {}
      }
    },

    created () {
      this.entity = processItems
      this.http = processItems.api || resolveHTTP(processItems.url)

      this.uploadUrl = this.http.storeByFileRoute()

      // Let's grab the most
      this.refreshCollection()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/bl/ProcessItems.vue